import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

// Los visitantes que ya conocían la web que ocupaba esta misma dirección antes
// conservan en su navegador copias guardadas de aquellas páginas, y el
// navegador las sigue sirviendo al entrar desde un buscador. En cuanto se
// detecta una de esas copias antiguas se retira, para que la visita vuelva a
// cargar la web actual.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      if (!registrations.length) return;
      registrations.forEach((registration) => registration.unregister());
      if (window.caches) {
        caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
      }
    })
    .catch(() => {});
}

// La portada se precarga en paralelo al bootstrap de auth, de forma que el chunk
// (Navbar, Hero…) ya está listo cuando la app sale del estado de carga y el header
// real sustituye al shell sin un round-trip serial extra en móvil.
import('@/pages/Home');

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)